/*
  Modal that wraps the shared SeatLayoutContainer (same one the Search page
  uses) so the operator can pick a different seat for a conflicting PNR.
  Stateless — the parent owns `reassignModal` state and the
  applySeatOverride / closeReassignModal callbacks.
*/
import React from 'react';
import { Empty, message, Modal, Space, Typography } from 'antd';
import { SeatLayoutContainer } from '../seat-layout/seat-layout-container.component';
import { isValidString } from '../../utils/utilities';

const { Text, Paragraph } = Typography;

export const ReassignSeatModal = ({ state, onClose, onPickSeat }) => (
    <Modal
        visible={state.open}
        title={(
            <Space>
                <Text strong>Pick another seat</Text>
                {state.pnr && (
                    <Text type="secondary">
                        {`PNR ${state.pnr} · replace seat ${state.oldSeatNumber}`}
                    </Text>
                )}
            </Space>
        )}
        width={720}
        footer={null}
        onCancel={onClose}
        destroyOnClose={true}
    >
        <Paragraph type="secondary" style={{ marginBottom: 8 }}>
            Click on a free seat in the layout below to use it for this PNR. The
            booking will replace the original seat number with the one you pick.
        </Paragraph>
        {state.loading ? (
            <Empty description="Loading seat layout…" />
        ) : (
            <SeatLayoutContainer
                seatsData={state.seats}
                blockedSeatAllowed={false}
                showFarePopOver={false}
                noOfSeatsAllowedToClick={1}
                tripId={state.tripId}
                showLegend={true}
                isDragDropRequired={false}
                onSeatClickSuccess={(seat) => {
                    const seatNumber = seat && seat.seat_number ? seat.seat_number : seat && seat.seatNumber;
                    if (!isValidString(seatNumber)) {
                        message.error('Could not read the selected seat number.');
                        return;
                    }
                    onPickSeat(seatNumber);
                }}
            />
        )}
    </Modal>
);
